<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- 戻る -->
    <div class="return">
      <button
        pButton
        type="button"
        label="課題・ソリューション検索へ戻る"
        icon="pi pi-angle-left"
        class="p-button-text"
        (click)="moveC201()"
      ></button>
    </div>
    <!-- 課題・ソリューションを登録した会員プロフィールへの遷移ボタン -->
    <div class="return">
      <button
        pButton
        type="button"
        label="会員プロフィールへ"
        icon="pi pi-angle-left"
        class="p-button-text"
        (click)="
          moveB211orMoveB212(detailTask?.member_id, detailTask?.class_id)
        "
      ></button>
    </div>
    <!-- 課題タイトル -->
    <div class="task-title">
      <!-- タイトルコンテンツ -->
      <div
        class="title-content p-d-flex"
        [class.past]="1 == detailTask?.past_issue && 1 == detailTask?.agenda_kbn.id"
      >
        <div class="p-col">
          <!-- タイトル -->
          <div
          class="title"
          [class.task-content-title]="1 == detailTask?.agenda_kbn.id"
          [class.solution-content-title]="2 == detailTask?.agenda_kbn.id"
          >
          {{ detailTask?.title }}
          </div>

          <!-- ブロック下部 -->
          <div class="footer-title-content p-d-flex p-jc-between">
          <div class="p-d-flex">
            <!-- 会員名 -->
            <div class="p-as-center agenda-organization_name">
              {{ detailTask?.organization_name }}
            </div>
            <!-- 公開タグ-->
            <div
              class="p-as-center board"
              *ngIf="
                0 != releaseFlag(detailTask?.status.id, detailTask?.end_date,detailTask?.agenda_kbn.id)
              "
            >
              <!-- 区分が1の場合 -->
              <p-tag
                value="公開"
                [rounded]="true"
                styleClass="content-public-tag"
                *ngIf="
                  1 == releaseFlag(detailTask?.status.id, detailTask?.end_date, detailTask?.agenda_kbn.id)
                "
              ></p-tag>
              <!-- 区分が2の場合 -->
              <p-tag
                value="非公開"
                [rounded]="true"
                styleClass="content-private-tag"
                *ngIf="
                  2 == releaseFlag(detailTask?.status.id, detailTask?.end_date, detailTask?.agenda_kbn.id)
                "
              ></p-tag>
            </div>

            <!-- 区分タグ -->
            <div class="p-as-center agenda-kbn">
              <!-- 区分が1の場合 -->
              <p-tag
                value="課題"
                styleClass="task-tag"
                *ngIf="1 == detailTask?.agenda_kbn.id"
              ></p-tag>
              <!-- 区分が2の場合 -->
              <p-tag
                value="ソリューション"
                styleClass="solution-tag"
                *ngIf="2 == detailTask?.agenda_kbn.id"
              ></p-tag>
            </div>

            <!-- 課題ID -->
            <div class="p-as-center agenda-id">No.{{ agendaId }}</div>
            <div class="future-city-badge p-d-flex p-ml-3" *ngIf="detailTask?.flag_future_city == '1'">
              <div class="icon">
                <img
                  src="../../../../assets/images/logo2.png"
                  alt="future-city-badge-icon"
                />
              </div>
              <div class="text">
                未来都市
              </div>
            </div>
          </div>
          <!-- fpt's part start: add follow button -->
          <ng-container  *ngIf="detailTask?.agenda_kbn?.id == 1">
            <span *ngIf="detailTask && detailTask.created_by_follow != '1' && detailTask.past_issue=='0'">
              <button
              pButton
              *ngIf="detailTask?.is_follower==0; else followed"
              type="button"
                  label="課題をフォロー {{
                    detailTask.follower_count >= 9999
                      ? '(9999)'
                      : detailTask.follower_count <= 0
                      ? ''
                      : '(' + detailTask.follower_count + ')'
                  }}"
                  class="follow-button"
                  (click)="
                    openConfirmFollowdialog(
                      detailTask.agenda_id,
                      detailTask.title,
                      detailTask.member_id
                    )
                  "
                ></button>
            <ng-template #followed>
              <button
                pButton
                type="button"
                    label="フォロー済 {{
                      detailTask.follower_count >= 9999
                        ? '(9999)'
                        : detailTask.follower_count <= 0
                        ? ''
                        : '(' + detailTask.follower_count + ')'
                    }}"
                    class="unFollow-button"
                    (click)="
                      openConfirmUnFollowdialog(
                        detailTask.agenda_id,
                        detailTask.title
                      )
                    "
                  ></button>
            </ng-template>
            </span>
          </ng-container>
          <!-- fpt's part end -->
          </div>
        </div>

      </div>
      <div class="past-issuse-notice-text">
        <span *ngIf="detailTask?.past_issue == '1' && 1 == detailTask?.agenda_kbn.id">
          ＊この課題の提案募集は既に終了しています。
        </span>
      </div>
      <!-- 編集ボタンエリア -->
      <div class="p-d-flex p-jc-end edit-button-group">
        <!-- 編集ボタン -->
        <button
          pButton
          type="button"
          label="編集する"
          icon="pi pi-pencil"
          class="button1"
          (click)="moveC101()"
          *ngIf="
          detailTask?.status.id != 3 &&
            ((decisionPerspective(this.detailTask?.member_id) ||
              decisionSecretariat()) &&
            detailTask &&
            detailTask.created_by_follow != '1')
          "
        ></button>
        <!--fpt's part start add citation button, follow/unfollow button-->
        <div
          class="p-d-flex p-ai-center"
          *ngIf="detailTask?.agenda_kbn?.id == 1"
        >
          <button
            *ngIf="this.loginUser"
            pButton
            type="button"
            icon="pi pi-pencil"
            label="この課題を引用して登録する"
            class="button1 buttonCitation"
            (click)="confirmQuotation()"
          ></button>
        </div>
        <!--fpt's part end-->
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <!-- 公開掲示板 -->
        <button
          pButton
          type="button"
          [label]="'公開掲示板（' + countQuestionBoard + '）'"
          class="button-default-size button2"
          (click)="moveChat()"
          *ngIf="
            1 == this.detailTask?.board_open.id &&
            (this.decisionPerspective(this.detailTask?.member_id) || this.decisionSecretariat())
            && !(this.detailTask?.agenda_kbn.id == 1 && this.detailTask?.past_issue == '1')
          "
        ></button>
      </div>
    </div>

    <!-- 内閣府承認情報 -->
    <div
      class="approval-information"
      *ngIf="
        decisionPerspective(this.detailTask?.member_id) || decisionSecretariat()
      "
    >
      <!-- 内閣府承認情報内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 内閣府承認 -->
          <tr>
            <td class="item-name">運営事務局承認</td>
            <td class="item-information">
              <div [class.denial]="3 == detailTask?.status.id">
                <div class="p-d-flex status">
                  <label class="p-as-center">
                    <!-- ステータス -->
                    <label class="status-name">
                      {{ detailTask?.status.name }}
                    </label>
                    <!-- 承認日付 -->
                    <label>
                      {{ detailTask?.status_date }}
                    </label>
                  </label>

                  <div>
                    <!-- 前後確認 -->
                    <button
                      pButton
                      type="button"
                      label="前後確認"
                      class="button3 approval-button"
                      (click)="openDiffDialog('c301')"
                      *ngIf="decisionSecretariat()"
                    ></button>
                    <!-- 承認可否 -->
                    <button
                      pButton
                      type="button"
                      label="ステータス登録"
                      class="button3 approval-button"
                      (click)="openSmallApprovalDialog()"
                      *ngIf="decisionSecretariat()"
                    ></button>
                  </div>
                </div>
                <!-- 承認時コメント -->
                <div class="status-comment">
                  {{ detailTask?.status_comment }}
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 課題の背景や詳細 -->
    <div class="task-detail">
      <!-- タイトル -->
      <div class="task-detail-title">
        <!-- 区分が1の場合 -->
        <div *ngIf="1 == detailTask?.agenda_kbn.id">
          <h1>課題の背景や詳細</h1>
        </div>
        <!-- 区分が2の場合 -->
        <div *ngIf="2 == detailTask?.agenda_kbn.id">
          <h1>ソリューションの詳細</h1>
        </div>
      </div>
      <!-- 課題情報 -->
      <div class="task-detail-information">
        <!-- 課題内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 区分 -->
            <tr>
              <td class="item-name">区分</td>
              <td class="item-information">
                <!-- 区分が1の場合 -->
                <p-tag
                  value="課題"
                  styleClass="task-tag"
                  *ngIf="1 == detailTask?.agenda_kbn.id"
                ></p-tag>
                <!-- 区分が2の場合 -->
                <p-tag
                  value="ソリューション"
                  styleClass="solution-tag"
                  *ngIf="2 == detailTask?.agenda_kbn.id"
                ></p-tag>
              </td>
            </tr>
            <!-- タイトル -->
            <tr>
              <td class="item-name">タイトル</td>
              <td class="item-information">{{ detailTask?.title }}</td>
            </tr>
            <!-- カテゴリ -->
            <tr>
              <td class="item-name">カテゴリ</td>
              <td class="item-information">
                <div *ngFor="let category of detailTask?.category">
                  {{ category.name }}
                </div>
              </td>
            </tr>
            <!-- ソリューション内容 -->
            <tr *ngIf="2 == detailTask?.agenda_kbn.id">
              <td class="item-name">ソリューション内容</td>
              <td class="item-information">
                {{ detailTask?.solution_detail }}
                <!-- 図・写真 -->
                <div
                  class="view-content"
                  *ngIf="detailTask?.image.file_path.length != 0"
                >
                  <img
                    [src]="detailTask?.image.file_path"
                    alt="image"
                    id="image1"
                    onerror="this.src= 'https://naikakufu-prod-file.s3.ap-northeast-1.amazonaws.com/image_proseccing.png'"
                  />
                </div>
              </td>
            </tr>
            <!-- 連携希望先 -->
            <tr *ngIf="2 == detailTask?.agenda_kbn.id">
              <td class="item-name">連携希望先</td>
              <td class="item-information">
                <div *ngFor="let image_group of detailTask?.image_group">
                  {{ image_group.name }}
                </div>
              </td>
            </tr>
            <!-- 解決したい課題内容 -->
            <tr *ngIf="1 == detailTask?.agenda_kbn.id">
              <td class="item-name">解決したい課題内容</td>
              <td class="item-information">
                {{ detailTask?.agenda }}
                <!-- 図・写真 -->
                <div
                  class="view-content"
                  *ngIf="detailTask?.image.file_path.length != 0"
                >
                  <img
                    [src]="detailTask?.image.file_path"
                    alt="image"
                    id="image1"
                    onerror="this.src= 'https://naikakufu-prod-file.s3.ap-northeast-1.amazonaws.com/image_proseccing.png'"
                  />
                </div>
              </td>
            </tr>
            <!-- 課題に対する現在の取り組み -->
            <tr *ngIf="1 == detailTask?.agenda_kbn.id">
              <td class="item-name">課題に対する現在の取組</td>
              <td class="item-information">{{ detailTask?.measures }}</td>
            </tr>
            <!-- 提案者側に期待すること -->
            <tr *ngIf="1 == detailTask?.agenda_kbn.id">
              <td class="item-name">提案者側に期待すること</td>
              <td class="item-information">{{ detailTask?.expectations }}</td>
            </tr>
            <!-- 定量的な目標値 -->
            <tr
              *ngIf="
                1 == detailTask?.agenda_kbn.id && detailTask?.target.length != 0
              "
            >
              <td class="item-name">定量的な目標値</td>
              <td class="item-information">{{ detailTask?.target }}</td>
            </tr>
            <!-- 現時点の予算状況 -->
            <tr *ngIf="1 == detailTask?.agenda_kbn.id">
              <td class="item-name">現時点の予算状況</td>
              <td class="item-information">
                <div>{{ getDicName(2021, detailTask?.budget.id) }}</div>
                <div>{{ detailTask?.budget_note }}</div>
              </td>
            </tr>
            <!-- 予算化の方法 -->
            <tr
              *ngIf="
                1 == detailTask?.agenda_kbn.id &&
                detailTask?.budget_method.length != 0
              "
            >
              <td class="item-name">予算化の方法</td>
              <td class="item-information">{{ detailTask?.budget_method }}</td>
            </tr>
            <!-- 目指すSDGsゴール -->
            <tr>
              <td class="item-name">目指すSDGsゴール</td>
              <td class="item-information target-goal">
                <div
                  class="image"
                  *ngFor="let sdgs_goal of detailTask?.sdgs_goal"
                >
                  <img [src]="sdgs_goal.sp_ext" alt="image" />
                </div>
              </td>
            </tr>
            <!-- ソリューション紹介WebサイトURL -->
            <tr
              *ngIf="
                2 == detailTask?.agenda_kbn.id &&
                detailTask?.solution_url.length != 0
              "
            >
              <td class="item-name">ソリューション紹介<br />ウェブサイトURL</td>
              <td class="item-information">
                <a [href]="detailTask?.solution_url" target="_blank"
                  >{{ detailTask?.solution_url }}
                </a>
              </td>
            </tr>
            <!-- ソリューション補足 -->
            <tr
              *ngIf="
                2 == detailTask?.agenda_kbn.id &&
                detailTask?.solution_note.length != 0
              "
            >
              <td class="item-name">ソリューション補足</td>
              <td class="item-information">{{ detailTask?.solution_note }}</td>
            </tr>
            <!-- 導入費用等の情報 -->
            <tr
              *ngIf="
                2 == detailTask?.agenda_kbn.id &&
                detailTask?.introcost_info.length != 0
              "
            >
              <td class="item-input-name">導入費用等の情報</td>
              <td class="item-information">{{ detailTask?.introcost_info }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- ボタンエリア -->
    <div
      class="button-area"
      *ngIf="
        !(
          decisionPerspective(this.detailTask?.member_id) ||
          decisionSecretariat()
        )
      "
    >
      <div class="p-d-flex p-jc-center chat-button-area">
        <!-- 公開掲示板 -->
        <button
          pButton
          type="button"
          [label]="'公開掲示板（' + countQuestionBoard + '）'"
          class="button-default-size button2"
          (click)="moveChat()"
          *ngIf="
            1 == this.detailTask?.board_open.id
            && this.decisionLoginState()
            && !(this.detailTask?.agenda_kbn.id == 1
              && this.detailTask?.past_issue == '1')
          "
        ></button>
      </div>
      <div class="p-d-flex p-jc-center" *ngIf="detailTask?.past_issue == '0'">
        <!-- マッチング依頼 -->
        <button
          pButton
          type="button"
          label="提案登録"
          class="button-default-size button1"
          (click)="moveC401()"
          *ngIf="
            2 != detailTask?.agenda_kbn.id &&
            loginUser &&
            detailTask?.created_by_follow != 1 &&
            detailTask?.agenda_kbn.id == 1 &&
            (detailTask?.is_follower == 0 ||
              (detailTask?.is_follower != 0 &&
                this.loginUser.class_id != 1 &&
                this.loginUser.class_id != 2))
          "
        ></button>
        <button
          pButton
          type="button"
          label="提案登録"
          class="button-default-size button1"
          (click)="loginToC401()"
          *ngIf="2 != detailTask?.agenda_kbn.id && !loginUser"
        ></button>
        <button
          pButton
          type="button"
          label="依頼登録"
          class="button-default-size button1"
          (click)="moveC401()"
          *ngIf="2 == detailTask?.agenda_kbn.id"
        ></button>
      </div>
    </div>

    <!-- マッチング依頼一覧 -->
    <div
      class="matching-list"
      *ngIf="
        (decisionPerspective(this.detailTask?.member_id) ||
          decisionSecretariat()) &&
        matchingList?.length
      "
    >
      <!-- タイトル -->
      <div class="matching-list-title">
        <!-- 区分が1の場合 -->
        <div *ngIf="1 == detailTask?.agenda_kbn.id">
          <h1>提案一覧</h1>
        </div>
        <!-- 区分が2の場合 -->
        <div *ngIf="2 == detailTask?.agenda_kbn.id">
          <h1>依頼一覧</h1>
        </div>
      </div>
      <!-- マッチング依頼一覧情報 -->
      <div class="matching-list-information">
        <!-- マッチング依頼一覧内容 -->
        <p-table
          [value]="matchingList"
          emptyMessage="データが存在しません"
          styleClass="information-Form"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="title">タイトル</th>
              <th class="status">ステータス</th>
              <th class="organization_name">会員名称</th>
              <th class="prefectures">地域</th>
              <th class="update_datetime">更新日時</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-matching>
            <tr class="matching-data">
              <!-- タイトル -->
              <td class="title-data" (click)="moveC601(matching.suggest_id)">
                {{ matching.title }}
              </td>
              <!-- ステータス -->
              <td class="status-data">
                <label
                  class="red"
                  *ngIf="!matching.status_agenda || 0 == matching.status_agenda"
                >
                  未回答
                </label>
                <label
                  *ngIf="matching.status_agenda && 0 != matching.status_agenda"
                  [class.green]="
                    1 == matching.status_agenda || 5 == matching.status_agenda
                  "
                >
                  <!-- 提案のステータス -->
                  <ng-container *ngIf="1 == detailTask?.agenda_kbn.id">{{
                    getDicName(901, matching.status_agenda)
                  }}</ng-container>
                  <!-- 依頼のステータス -->
                  <ng-container *ngIf="2 == detailTask?.agenda_kbn.id">{{
                    getDicName(2026, matching.status_agenda)
                  }}</ng-container>
                </label>
              </td>
              <!-- 会員名称 -->
              <td>
                {{ matching.organization_name }}
              </td>
              <!-- 地域 -->
              <td>
                {{ matching.prefectures }}
              </td>
              <!-- 更新日 -->
              <td>
                {{ matching.update_datetime }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<!-- 共通部品_承認時ダイアログ -->
<app-approval-dialog (returnApproval)="getDetailTask()"></app-approval-dialog>

<!-- 共通部品_チャット -->
<app-chat></app-chat>

<!-- 共通部品_差分比較ダイアログ -->
<app-diff-table></app-diff-table>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
<!-- fpt added: follow/unfollow dialog -->
<app-follow-dialog (returnValue)="reload()"></app-follow-dialog>
<!-- fpt added: citing dialog -->
<app-confirm-quotation-dialog
  (returnValue)="moveC101(true)"
></app-confirm-quotation-dialog>
